import {
    REQUEST_SYSTEM_LOGS,
    REQUEST_SYSTEM_LOGS_SUCCESS,
    REQUEST_SYSTEM_LOGS_FAILURE
} from "../../constant/other/SystemLogConstant";

const initialState = {
    systemLogs: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const systemLogsReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_SYSTEM_LOGS:
            return {
                ...state,
                systemLogs: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_SYSTEM_LOGS_SUCCESS:
            return {
                ...state,
                systemLogs: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_SYSTEM_LOGS_FAILURE:
            return {
                ...state,
                systemLogs: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
